module.exports = __webpack_public_path__ + "img/chat-video-message.b30583da.svg";